export default {
  id: 20,
  title: 'Target #20 - Ticket',
  url: 'https://cssbattle.dev/play/20',
  colors: ['#62306D', '#F7EC7D', '#E38F66'],
  solution:
    '<a a><a b><a c><style>body{background:#62306d}a{position:fixed}a[a]{top:100;left:100;width:200;height:100;background:linear-gradient(90deg,#f7ec7d 70%,#e38f66 70%)}a[b],a[c]{border-radius:50%;background:#62306d}a[b]{top:80;left:80;width:40;height:40;box-shadow:200px 0 #62306d,0 100px #62306d,200px 100px #62306d}a[c]{top:90;left:230;width:20;height:20;box-shadow:0 100px #62306d}</style>',
}
